import {
  getAccountsCreatedPending, getAccountsCreatedSuccess, getAccountsCreatedError,
  getCumulativeUserCountPending, getCumulativeUserCountSuccess, getCumulativeUserCountError,
  getJobApplicationCountPending, getJobApplicationCountSuccess, getJobApplicationCountError,
  getJobPostsCreatedPending, getJobPostsCreatedSuccess, getJobPostsCreatedError,
} from '../../actions/admin/metrics';

import {MetricsService} from '../../../lib/qc-api-client';

export function getAccountsCreated() {
  return dispatch => {
    dispatch(getAccountsCreatedPending());
    MetricsService.getAccountsCreated().then(response => {
      dispatch(getAccountsCreatedSuccess({
        metrics: response.data.metrics,
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getAccountsCreatedError(error));
    })
  }
}

export function getCumulativeUserCount() {
  return dispatch => {
    dispatch(getCumulativeUserCountPending());
    MetricsService.getCumulativeUserCount().then(response => {
      dispatch(getCumulativeUserCountSuccess({
        metrics: response.data.metrics,
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getCumulativeUserCountError(error));
    })
  }
}

export function getJobApplicationCount() {
  return dispatch => {
    dispatch(getJobApplicationCountPending());
    MetricsService.getJobApplicationCount().then(response => {
      dispatch(getJobApplicationCountSuccess({
        metrics: response.data.metrics,
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getJobApplicationCountError(error));
    })
  }
}

export function getJobPostsCreated() {
  return dispatch => {
    dispatch(getJobPostsCreatedPending());
    MetricsService.getJobPostsCreated().then(response => {
      dispatch(getJobPostsCreatedSuccess({
        metrics: response.data.metrics,
      }));
    }).catch(error => {
      console.error(error)
      dispatch(getJobPostsCreatedError(error));
    })
  }
}
